// --- Other imports ---
import Lenis from "lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Alpine from "alpinejs";

// Register plugins before usage
gsap.registerPlugin(ScrollTrigger);

// Smooth scrolling — initialize Lenis for all devices
let lenis = null;
window.lenis = null;

const isMobile = window.innerWidth <= 768;

lenis = new Lenis({
  lerp: isMobile ? 0.08 : 0.1,
  wheelMultiplier: isMobile ? 0.8 : 1,
  infinite: false,
  gestureOrientation: "vertical",
  normalizeWheel: false,
  syncTouch: isMobile ? true : false,
  touchMultiplier: isMobile ? 1.5 : 2,
  autoRaf: false,
});

window.lenis = lenis;

lenis.on("scroll", () => {
  ScrollTrigger.update();
});

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(250, 16);

ScrollTrigger.defaults({
  scroller: document.body,
});

ScrollTrigger.addEventListener("refresh", () => lenis.resize());
ScrollTrigger.refresh();

export { lenis };

// Fancybox
Fancybox.bind("[data-fancybox]", {});

// Masonry
window.initMasonry = function () {
  const grid = document.querySelector("#masonry-grid");
  if (!grid) return;
  imagesLoaded(grid, () => {
    setTimeout(() => {
      new Masonry(grid, {
        itemSelector: ".grid-item",
        percentPosition: true,
        gutter: 24,
      });
    }, 10);
  });
};
window.initMasonry();

// Alpine.js
document.addEventListener("DOMContentLoaded", () => {
  if (!window.Alpine) {
    window.Alpine = Alpine;
    Alpine.start();
  }

  const toTopBtn = document.querySelector(".toTop");
  const footer = document.querySelector("footer");

  if (toTopBtn) {
    toTopBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (lenis) {
        lenis.scrollTo(0, { lerp: 0.2 }); // You can tweak lerp for speed
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });

    if (footer) {
      function checkFooterOverlap() {
        const btnRect = toTopBtn.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        // If the bottom of the button is greater than the top of the footer, they're overlapping (on viewport)
        if (btnRect.bottom > footerRect.top) {
          toTopBtn.classList.add("white");
        } else {
          toTopBtn.classList.remove("white");
        }
      }

      // Listen for Lenis scroll and resize
      if (lenis) {
        lenis.on("scroll", checkFooterOverlap);
      } else {
        window.addEventListener("scroll", checkFooterOverlap);
      }
      window.addEventListener("resize", checkFooterOverlap);

      // Also run on load
      checkFooterOverlap();
    }
  }
});

// --- Lastly: Import your own scripts that use `lenis` or `ScrollTrigger` ---
import "./sfeerbeelden.js";
import "./favicon.js";
import "./boxSizing.js";
import "./animations.js"; // This now has access to fully working lenis + ScrollTrigger
import "./menu.js";
import "./slider.js";
import "./cart.js";
import "./leaflet.js";
